import { useContext } from "react";
import "./ViewSezioneComponent.scss";
import PropTypes from "prop-types";
import { AppContext } from "../../../../../../contexts/appContext";
import { BREADCRUMB_MAP } from "../../../../../../utils/BreadcrumbEnums";
import BreadcrumbComponent from "../../../../../../components/BreadcrumbComponent/BreadcrumbComponent";
import { CategoryTitle } from "../../../../../../components/styled-components";
import CategoryDetailCarouselComponent from "../CategoryDetailCarouselComponent/CategoryDetailCarouselComponent";
import CategoryDetailListLink from "../CategoryDetailListLink/CategoryDetailListLink";
import { Tipologie } from "../../../../../../utils/TipologiaEnums";
import { Helmet } from "react-helmet";
import { APP_NAME } from "../../../../../../utils/Constans";

/**
 * @function ViewSezioneComponent test components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
*/
const ViewSezioneComponent = ({ info}) => { 
    const { menu, imaginiForCarousel } = useContext( AppContext );
    const currentSection = menu?.find( m => m.tipologia === info?.tipologia );

    return (
        <>
            <BreadcrumbComponent items={ [ BREADCRUMB_MAP.HOME_PAGE ] }></BreadcrumbComponent>
            <Helmet>
                <title>{APP_NAME} | { info.title }</title>
            </Helmet>
            <CategoryTitle><div role="contentinfo" tabIndex="0" aria-label={ info.title }>{ info.title }</div></CategoryTitle>
            <CategoryDetailCarouselComponent
                images={ imaginiForCarousel?.[ Tipologie.find( item => item?.tipologia === info?.tipologia )?.id ] }
                voci={ currentSection?.voci }
            >

            </CategoryDetailCarouselComponent>
            <CategoryDetailListLink voci={ currentSection?.voci } isSection={ true }></CategoryDetailListLink>
        </>

    );
};

ViewSezioneComponent.propTypes = {
    menu: PropTypes.string.isRequired,
};

ViewSezioneComponent.defaultProps = {
    menu: "",
};

export default ViewSezioneComponent;